import { render, staticRenderFns } from "./thoughtArticle.vue?vue&type=template&id=d01e2daa&scoped=true"
import script from "./thoughtArticle.vue?vue&type=script&lang=js"
export * from "./thoughtArticle.vue?vue&type=script&lang=js"
import style0 from "./thoughtArticle.vue?vue&type=style&index=0&id=d01e2daa&prod&scoped=true&lang=css"
import style1 from "./thoughtArticle.vue?vue&type=style&index=1&id=d01e2daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01e2daa",
  null
  
)

export default component.exports